import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatTableModule } from "@angular/material/table";
import { DashboardComponent } from "./retrofit/dashboard/dashboard.component";
import { RetrofitDashboardTableComponent } from "./retrofit/dashboard/retrofit-dashboard-table/retrofit-dashboard-table.component";
import { MatIconModule } from "@angular/material/icon";
import { ResourcesDownloadComponent } from "./retrofit/dialog/resources-download/resources-download.component";
import { MatDialogModule } from "@angular/material/dialog";
import { MatRadioModule } from "@angular/material/radio";
import { FormsModule } from "@angular/forms";
import { MetadataComponent } from "./retrofit/dialog/metadata/metadata.component";
import { MatTabsModule } from "@angular/material/tabs";
import { FinalPdfReportComponent } from './retrofit/final-pdf-report/final-pdf-report.component';
import { MatButtonModule } from "@angular/material/button";
import { MatTooltipModule } from "@angular/material/tooltip";
import { VahanPortalComponent } from './vahan-portal/vahan-portal.component';
import { RetrofitRawDataComponent } from './retrofit/retrofit-raw-data/retrofit-raw-data.component';
import { MatSelectModule } from "@angular/material/select";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatCardModule } from "@angular/material/card";
import { ChartModule } from "angular-highcharts";

@NgModule({
  declarations: [
    DashboardComponent,
    RetrofitDashboardTableComponent,
    ResourcesDownloadComponent,
    MetadataComponent,
    FinalPdfReportComponent,
    VahanPortalComponent,
    RetrofitRawDataComponent,
  ],
  imports: [
    CommonModule,
    MatTableModule,
    MatPaginatorModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatRadioModule,
    MatDialogModule,
    FormsModule,
    MatTabsModule,
    MatButtonModule,
    MatTooltipModule,
    MatSelectModule,
    MatDatepickerModule,
    MatCardModule,
    ChartModule,
  ],
  exports: [VahanPortalComponent],
})
export class OtoModule {}
